import { Input, Button, Typography } from "antd";
import AnimateHeight from "react-animate-height";
import { TwitterOutlined, PhoneFilled } from "@ant-design/icons";
const { Text } = Typography;
const { Title } = Typography;

const Header = (props) => {
  const openTwitter = () => {
    const url = "https://twitter.com/catchyshoppp?lang=en";
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  return (
    <div style={{ marginTop: 10 }}>
      <AnimateHeight
        id="example-panel"
        duration={1000}
        height={props.height}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div style={{ margin: "auto", padding: "0px 20px" }}>
          <Title>Catchy Shop</Title>
          <div style={{ marginTop: -10 }}>
            <Text>เช็คสถานะสินค้า (ใส่ @ หน้า Account ด้วยนะคั้บ)</Text>
          </div>
          <div
            style={{
              width: "70vw",
              maxWidth: 500,
              marginTop: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Input
              placeholder="@Twitter"
              prefix={<TwitterOutlined />}
              value={props.twitter}
              onChange={(e) => props.setTwitter(e.target.value)}
            />
            <Button
              type="primary"
              style={{ width: "100%", marginTop: 10 }}
              onClick={props.onSearch}
            >
              Search
            </Button>
            <div
              style={{ marginTop: 5, cursor: "pointer" }}
              onClick={() => openTwitter()}
            >
              <img
                src={process.env.PUBLIC_URL + "/twitter.svg"}
                alt="loading"
                style={{ width: "1.5rem" }}
              />
              <Text style={{ color: "#1DA1F2" }}>@catchyshoppp</Text>
            </div>
          </div>
        </div>
      </AnimateHeight>
      <center>
        {props.loading && (
          <img
            src={process.env.PUBLIC_URL + "/loading.svg"}
            alt="loading"
            style={{ width: "5rem" }}
          />
        )}
      </center>
    </div>
  );
};

export default Header;
